module.exports = __webpack_public_path__ + "static/master-5325b91b4718dac7988b97ab0cf44b6f.webp";